"use strict";
/*
 *
 * Generator of type-safe reducer and dispatches
 * Replaces the need for switch(){} statements
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureState = exports.generateDispatch = exports.generateReducer = void 0;
function assertExhaustive(caseType) {
    throw new Error("Non-exhaustive switch. Unhandled case: " + caseType);
}
var generateReducer = function (object) {
    return function (state, action) {
        return typeof object[action.type] === 'function'
            ? object[action.type]({
                state: state,
                action: action,
            })
            : assertExhaustive(action.type);
    };
};
exports.generateReducer = generateReducer;
var generateDispatch = function (object) {
    return function (action) {
        return typeof object[action.type] === 'function'
            ? object[action.type](action)
            : assertExhaustive(action.type);
    };
};
exports.generateDispatch = generateDispatch;
/*
 * Wrap Action handler in this function to ensure only certain states
 * Are allowed to emit this action
 */
function ensureState(emittedFrom, handler) {
    return function (_a) {
        var state = _a.state, action = _a.action;
        if (emittedFrom.includes(state.type))
            return handler({
                state: state,
                action: action,
            });
        else
            throw new Error("Action called from state " + state.type + ". " +
                ("Allowed states: " + emittedFrom.join(', ')));
    };
}
exports.ensureState = ensureState;
